export class ModalBackdropOptions {
  animate = true;

  constructor(options: ModalBackdropOptions) {
    Object.assign(this, options);
  }
}



// WEBPACK FOOTER //
// ./.tmp/modal/modal-backdrop.options.ts